// extracted by mini-css-extract-plugin
export default {"image":"image--Uw1UFfoYcGZ5g0b"};